/**
 * React component representing the main section for staying updated, including mailing list, quick links, and footers.
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.data - Data for rendering the stay updated section.
 * @returns {JSX.Element} The rendered StayUpdatedMain component.
 */


import React from "react";
import QuickLinks from "./QuickLinks";
import StayUpdatedSection from "./StayUpdatedSection";
import CopyRights from "./CopyRights";
import FooterMaticWeb from "./FooterMaticWeb";
import FooterMaticMobile from "./FooterMaticMobile";

const StayUpdatedMain = ({ data }) => {
  return (
    <>
      <section id="join-our-mailing-list">
        <div
          className={`relative place-content-start lg:place-content-center grid lg:grid-cols-12 grid-cols-6 lg:gap-x-0`}
        >
          <div
            className={`lg:col-span-6 col-span-6 bg-primary lg:border-r border-b lg:border-white/40`}
          >
            <StayUpdatedSection data={data} />
          </div>
          <div
            className={`lg:col-span-6 col-span-6 bg-primary flex justify-center items-center md:border-l border-t md:border-t-0 border-white40`}
          >
            <QuickLinks data={data} />
          </div>
        </div>
        <div className="lg:block hidden border-y border-white40 bg-primary">
          <FooterMaticWeb data={data} />
        </div>
        <div className="lg:hidden block border-y border-white40 bg-primary">
          <FooterMaticMobile data={data} />
        </div>
        <div className="bg-primary">
          <CopyRights data={data} />
        </div>
      </section>
    </>
  );
};

export default StayUpdatedMain;
